// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"164":"24be9200","331":"9fc8c565","387":"24be9200","484":"67e12160","888":"454a7a1c"}[chunkId] + ".css";
};